var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB2WeakWind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.93 10.13L21 34.25V10h-4v57h4V35.57l36.94 11.19 4.81-8.32-27.82-28.31zM26.34 33l9.42-16.33 3.58 3.64-8.17 14.16L26.34 33zM43 38l-5.89-1.78 6.63-11.5 4.37 4.44L43 38zm13.11 4l-7.21-2.18 3.57-6.19 5.33 5.43L56.11 42z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B2_Weak_wind.2678579f.svg";
export { SvgB2WeakWind as ReactComponent };